import React from 'react';

const Header: React.FC = () => {
  return (
    <header style={{ width: '100%', backgroundColor: '#333333', padding: '20px', position: 'sticky', top: 0, zIndex: 100 }}>
      <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', maxWidth: '1200px', margin: '0 auto' }}>
        <h1 style={{ margin: 0, color: '#ff4500' }}>Rust Reduction</h1>
        <ul style={{ listStyle: 'none', display: 'flex', gap: '20px', margin: 0 }}>
          <li><a href="#hero" style={{ color: '#ffffff', textDecoration: 'none' }}>Home</a></li>
          <li><a href="#about" style={{ color: '#ffffff', textDecoration: 'none' }}>About</a></li>
          <li><a href="#services" style={{ color: '#ffffff', textDecoration: 'none' }}>Services</a></li>
          <li><a href="#gallery" style={{ color: '#ffffff', textDecoration: 'none' }}>Gallery</a></li>
          <li><a href="#contact" style={{ color: '#ffffff', textDecoration: 'none' }}>Contact</a></li>
          <li><a href="https://www.instagram.com/rust_reduction/" target="_blank" rel="noopener noreferrer" style={{ color: '#ff4500', textDecoration: 'none' }}>Instagram</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;